/**
 * WooCommerce
 *
 */
import WooCheckout from './woocommerce/checkout';
import Filters from './woocommerce/filters';
import Render from './woocommerce/render';

window.addEventListener('DOMContentLoaded', () => {
	WooCheckout();
	new Filters(); // Init the filters
	new Render(); // Init the renderer for status and notification
});



/**
 * Non WooCommerce
 *
 */
import Accordion from './accordion';
import Scroll from './animations/scroll';
import Heights from './matchHeight';
import Sliders from './sliders';
import Filter from './filters';
import Menu from './menu';
import Tabs from "./tabs";
import Benefits from './animations/benefits';
import SmoothScroll from './animations/smooth-scroll';
import WooCommercePrices from './woocommerce/prices';
import WooCommerceButtons from './woocommerce/buttons';
import Gallery from "./gallery";
import Popup from './popup';

window.addEventListener('DOMContentLoaded', () => {

	Accordion();
	Heights();
	Sliders();
	Filter();
	new Menu();
	new WooCommercePrices();
	new WooCommerceButtons();
	new Gallery();
	new Popup();


	const tabs = document.querySelectorAll('.js-tabs');

	if (tabs.length) {
		tabs.forEach(tab => {
			new Tabs(tab);
		})
	}

	new Scroll(
		document.querySelectorAll('[data-fade-in]'),
		{
			opacity: 0,
			top: 20,
			position: 'relative'
		},
		{
			opacity: 1,
			top: 0,
			duration: 1.25,
		}
	)

	new Scroll(
		document.querySelectorAll('[data-fade-pos]'),
		{
			opacity: 0,
		},
		{
			opacity: 1,
			duration: 1.25,
		}
	)

	new Scroll(
		document.querySelectorAll('[data-slide-in]'),
		{
			opacity: 0,
			top: 20,
			scale: 1,
		},
		{
			scale: 1.05,
			opacity: 1,
			top: 0,
			duration: 1.25,
			transformOrigin: "bottom"
		}
	)

	new Scroll(
		document.querySelectorAll('[data-slide-in-large]'),
		{
			opacity: 0,
			scale: 1,
		},
		{
			scale: 1.05,
			opacity: 1,
			duration: 1,
			transformOrigin: "bottom"
		}
	)

	new Benefits;
	new SmoothScroll();
})
